import styled from 'styled-components';

export default styled.div`
  form {
    display: block;
  }
  .coupons-setting-box-4fr {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 32px;
  }
  .coupons-setting-box-2fr {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 32px;
  }
`;
